import { useContextState } from "../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    documentItems: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignitems: 'center',
      height: '120px',
      margin: '0px',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: '10px 10px',
      borderRadius: '5px',
      backgroundColor: colors.color25,
      color: `${colors.color13}`,
      '&:hover': {
        backgroundColor: `${colors.backgroundDark}20`,
      },
      '& .MuiIcon-root': {
        color: `${colors.color13}`,
        height: '35px',
        width: '35px',
      },
      '& .MuiSvgIcon-root': {
        color: `${colors.color13}`,
        height: '35px',
        width: '35px',
      },
    },
    boxIcon: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      textAlign: 'center',
    },
    comments: {
      padding: '15px',
      width: '100%',
      height: '120px',
      alignContent: 'center'
    },
    videos: {
      width: '100%',
      height: '120px',
      position: 'relative',
      '& video': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      margin: '0px'
    },
    images: {
      width: '100%',
      height: '120px',
      position: 'relative',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      margin: '0px'
    },
    expand: {
      position: 'absolute',
      bottom: '5px',
      right: '5px',
      color: colors.color5,
      backgroundColor: '#00000022',
      fontSize: '25px',
      width: '30px',
      height: '30px',
      '& .MuiSvgIcon-root': {
        fontSize: 'inherit',
        width: 'inherit',
        height: 'inherit'
      }
    },
  }
}

export { useStyles }